module.exports = globalThis.mcData["blockCollisionShapes"]